import Swal from 'sweetalert2'

export const customSwal = Swal.mixin({
  confirmButtonColor: '#007BC3',
  confirmButtonText: 'Aceptar',
})
